import React from "react";

export function Card({ children, className = "", ...props }) {
  return (
    <div className={`rounded-2xl bg-white shadow-md overflow-hidden ${className}`} {...props}>
      {children}
    </div>
  );
}